var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"indicator-overlay-wrapper"},[_c('div',{staticClass:"overlay"}),_c('div',{staticClass:"indicator-wrapper"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"white","indeterminate":""}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }